<template>
  <div class="container" :style="heightStyle">
    <!-- this.DetailsPespectives.Financiera.obj -->
    <el-row :gutter="40" v-if="statistics">
      <template v-for="(stat, index) in statistics">
        <el-col :key="index" :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
          <CardSatCmi
            :title="stat['Perspective']['Name']"
            :percent="parseInt(stat.Percentaje)"
            :loading.sync="loadingStadistic"
            :icon="getIconST(stat['Perspective']['Name'])"
            :objetive-completed="stat.ObjetiveCompleted"
            :objetive-total="stat.ObjetiveTotal"
            :task-completed="stat.TaskCompleted"
            :task-total="stat.TaskTotal"
            :subtask-completed="stat.SubTaskCompleted"
            :subtask-total="stat.SubTaskTotal"
            :gantt="true"
            countTooltipText="Porcentaje de la perspectiva"
          >
          </CardSatCmi>
        </el-col>
      </template>
    </el-row>

    <el-row :gutter="40">
      <template>
        <div style="float: right; margin-right: 25px">
          <el-switch
            v-model="showCards"
            active-text="Mostrar cards"
            inactive-text="Ocultar cards"
            :disabled="loading"
          >
          </el-switch>
        </div>
      </template>
    </el-row>

    <el-alert
      v-if="activeName != 1"
      style="
        width: 400px;
        margin-top: 10px;
        margin-bottom: 10px;
        font-size: 20px;
        background-color: tan;
      "
      title="Tomar en cuenta lo siguiente"
      description="Las tareas completadas se verán en el tab 'TODAS LAS TAREAS',
      con su respectivo filtro. En los diferentes tabs, solo se mostrarán las tareas pendientes de completar."
      type="warning"
      effect="dark"
      show-icon
    >
    </el-alert>

    <div style="display: flex; justify-content: end; margin-bottom: 5px">
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="año"
        placement="top"
      >
        <YearsComponent
          ref="yearSelector"
          @change="handleryear"
          :initial="2023"
          :max="yearMax"
          :specificYear="2033"
          class="box-item"
          size="mini"
          v-model="year"
          :disabled="loading"
        />
      </el-tooltip>

      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Cuatrimestre"
        placement="top"
      >
        <el-select
          v-model="fourMonthPeriodType"
          placeholder="Cuatrimestre"
          size="mini"
          filterable
          v-bind="$attrs"
          :disabled="loading"
          @change="handleChangeFourMonthPeriodType"
        >
          <el-option
            v-for="item in fourMonthPeriod"
            :key="item.Value"
            :label="item.Label"
            :value="item.Value"
          >
          </el-option>
        </el-select>
      </el-tooltip>
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Mes"
        placement="top"
      >
        <MonthsComponent
          :Quater="fourMonthPeriodType"
          :isDisabled="loading"
          @change="handlerMonth"
        />
      </el-tooltip>
    </div>

    <div style="position: relative; float: right">
      <!-- select tipo de objectivo -->
      <el-switch
        v-if="this.confirmRoles()"
        v-model="creadoPorMi"
        @change="GetGanttObjectives"
        active-text="Creados por mi"
        style="margin-right: 10px"
        :disabled="loading"
      >
      </el-switch>
      <!-- <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Tipo"
        placement="top"
      >
        <el-select
          v-model="Strategic"
          placeholder="Tipo"
          size="mini"
          filterable
          v-bind="$attrs"
          :disabled="loading"
        >
          <el-option
            v-for="item in Strategics"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-tooltip> -->

      <!-- select Perspectiva -->
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Perspectiva"
        placement="top"
      >
        <el-select
          v-model="PerpectiveId"
          placeholder="Perspectiva"
          size="mini"
          filterable
          v-bind="$attrs"
          :disabled="loading"
        >
          <el-option
            v-for="item in listOptionsObjectives"
            :key="item.Value"
            :label="item.Label"
            :value="item.Value"
          >
          </el-option>
        </el-select>
      </el-tooltip>

      <!-- select directionId -->
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Gerencia"
        placement="top"
      >
        <el-select
          v-if="this.currentUser.EmployeeId == 37"
          v-model="directionId"
          filterable
          clearable
          size="mini"
          placeholder="Gerencias"
          :disabled="loading"
          @change="handleChangeDirection"
        >
          <el-option
            v-for="item in directions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-tooltip>

      <!-- select responsable -->
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Responsabilidad"
        placement="top"
      >
        <!-- v-if="activeName == 1" -->
        <el-select
          v-model="responsableSelect"
          filterable
          clearable
          size="mini"
          placeholder="Responsabilidad"
          :disabled="loading"
          @change="updateSelectedResponsable"
        >
          <el-option
            v-for="item in ResponsableList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-tooltip>

      <!-- select employeeId -->
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Colaborador"
        placement="top"
      >
        <el-select
          v-if="this.currentUser.EmployeeId == 37"
          v-model="employeeId"
          filterable
          clearable
          size="mini"
          placeholder="Colaborador"
          :disabled="loading"
          @change="updateSelectedEmployee"
        >
          <el-option
            v-for="item in employees"
            :key="item.EmployeeID"
            :label="item.Name"
            :value="item.EmployeeID"
          >
          </el-option>
        </el-select>
      </el-tooltip>

      <!-- select employeeId -->
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Colaborador"
        placement="top"
      >
        <el-select
          v-if="this.currentUser.EmployeeId != 37 && this.confirmRoles()"
          v-model="employeeId"
          filterable
          clearable
          size="mini"
          placeholder="Colaborador"
          :disabled="loading"
          @change="updateSelectedEmployee"
        >
          <el-option
            v-for="item in employeesByDirection"
            :key="item.EmployeeID"
            :label="item.Name"
            :value="item.EmployeeID"
          >
          </el-option>
        </el-select>
      </el-tooltip>

      <!-- select status -->
      <el-tooltip
        style="padding: 0px; margin: 0px"
        class="item"
        effect="dark"
        content="Estado"
        placement="top"
      >
        <!-- v-if="activeName == 1" -->
        <el-select
          v-model="statusSelect"
          filterable
          clearable
          size="mini"
          placeholder="Status"
          :disabled="loading"
          @change="updateSelectedStatus"
        >
          <el-option
            v-for="item in StatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-tooltip>
    </div>

    <div style="margin-top: 80px; display: flex">
      <el-button size="mini" type="info" @click="toggleGridFunction()">{{
        toggleGrid ? "Ocultar Detalles" : "Abrir Detalles"
      }}</el-button>

      <el-button size="mini" type="info" @click="toggleChartFunction()">{{
        toggleChart ? "Ocultar Gráfico" : "Abrir Gráfico"
      }}</el-button>

      <el-button size="mini" type="success" @click="expandAll()">{{
        "Abrir Tareas"
      }}</el-button>

      <el-button size="mini" type="danger" @click="collapseAll()">{{
        "Ocultar Tareas"
      }}</el-button>
    </div>

    <el-dialog
      title="SUBIR EVIDENCIAS"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onEvidenceClose"
      width="30%"
    >
      <span>Subir Evidencias</span>

      <el-upload
        ref="uploadFile"
        class="upload-demo"
        :drag="true"
        action="https://apicloud.magycorp.com:48028/api/gallery/uploadanyFile"
        :limit="1"
        :on-exceed="handleExceed"
        list-type="picture-card"
        :auto-upload="false"
        :multiple="true"
        :on-success="handleUploadOnSuccess"
        :on-change="handleChange"
        :on-remove="handleRemove"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          Suelta tu archivo aquí o <em>haz clic para cargar</em>
        </div>
      </el-upload>

      <span slot="footer" class="dialog-footer">
        <el-button @click="cancellUpload">Cancel</el-button>
        <el-button type="primary" v-if="filesUpload > 0" @click="submitUpload"
          >Confirm</el-button
        >
      </span>
    </el-dialog>

    <TabGanttTask
      @getTasks="handleClick"
      :activeName="activeName"
      :totalTask="tasks.totalTask"
    />

    <GanttComponent
      v-loading="loading"
      class="left-container"
      :tasks="tasks"
      :PerpectiveId="PerpectiveId"
    ></GanttComponent>
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent.vue";
import MonthsComponent from "@/components/Global_System/MonthsComponent";
import GanttComponent from "./GanttComponent";
import TabGanttTask from "./TabGanttTask";
import CardSatCmi from "@/components/cmi/CardStatCmi.vue";
import { gantt } from "dhtmlx-gantt";
import { formatArrayToElSelect } from "@/utils";
import {
  SaveGantt,
  DeleteGantt,
  CompleteGantt,
  GetObjectives,
  GetStadistict,
  TaskClose,
  Setlightbox,
  GetEmployee
} from "./functions";

const yearNow = new Date().getFullYear();
const monthNow = 0; // new Date().getMonth() + 1;
export default {
  name: "GanttObjectives",
  components: {
    GanttComponent,
    CardSatCmi,
    TabGanttTask,
    YearsComponent,
    MonthsComponent
  },
  props: {
    Strategic: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isSupervisor: false,
      heightContainer: "140vh",
      heightStyle: {
        height: "140vh"
      },
      activeName: 1,
      OpenObjeID: 0,
      creadoPorMi: false,
      myEmployeeId: 0,
      loading: false,
      loadingStadistic: false,
      directions: [],
      employees: [],
      employeesByDirection: [],
      employeesList: [],
      employeeId: "",
      directionId: 28,
      PerpectiveId: 2,
      year: yearNow,
      yearMax: yearNow + 5,
      month: monthNow,
      listOptionsObjectives: [
        { Value: 0, Label: "Todos" },
        { Value: 1, Label: "Financiera" },
        { Value: 2, Label: "Del cliente" },
        { Value: 3, Label: "Procesos internos" },
        { Value: 4, Label: "Desarrollo y Aprendizaje" }
      ],
      listProgress: [
        // { id: 0, text: "0%" },
        { key: 25, label: "25%" },
        { key: 50, label: "50%" },
        { key: 75, label: "75%" },
        { key: 100, label: "100%" }
      ],
      fourMonthPeriodType: 0,
      fourMonthPeriod: [
        { Value: 0, Label: "Todos" },
        { Value: 1, Label: "Q1" },
        { Value: 2, Label: "Q2" },
        { Value: 3, Label: "Q3" },
        { Value: 4, Label: "Q4" }
      ],
      // Strategics: [
      //   { value: 0, label: "Todos" },
      //   { value: 1, label: "Operacionales" },
      //   { value: 2, label: "Estratégico" }
      // ],
      statusSelect: 1,
      StatusList: [
        { value: 0, label: "Todos" },
        { value: 1, label: "En proceso ⏳" },
        { value: 2, label: "Pendientes de aprobación 🕑" },
        { value: 3, label: "Aprobados ✔️" },
        { value: 4, label: "Objetivos completados ✔️" }
      ],
      responsableSelect: 0,
      ResponsableList: [
        { value: 0, label: "Todos" },
        { value: 1, label: "Asignadas a mi" },
        { value: 2, label: "Supervisadas por mi" }
      ],
      listOwners: [],
      tasks: {
        data: [],
        links: [],
        totalTask: 0
      },
      // Strategic: 0,
      toggleGrid: true,
      toggleChart: true,
      dialogVisible: false,
      fileList: [],
      filesUpload: 0,
      DetailsPespectives: {
        Financiera: {
          name: "Financiera",
          icon: "el-icon-bank-card accent-text",
          obj: [],
          tasks: []
        },
        Delcliente: {
          name: "Del Cliente",
          icon: "el-icon-bank-card accent-text",
          obj: [],
          tasks: []
        },
        ProcesosInternos: {
          name: "Procesos Internos",
          icon: "el-icon-coin warning-text",
          obj: [],
          tasks: []
        },
        DesarrolloAprendizaje: {
          name: "Desarrollo y Aprendizaje",
          icon: "el-icon-setting purple-text",
          obj: [],
          tasks: []
        }
      },
      statistics: [],
      showCards: true,
      TaskProgressOlds: 0,
      totalTask: 0
    };
  },
  async mounted() {
    await this.onTaskClose();
    // await this.ClickTask();
    await this.getEmployeesLits();
    await this.GetEmployeeByName();
    await this.getEmployees();
    await this.GetGanttObjectives();
    await this.formGantt(this.PerpectiveId);
  },
  async created() {
    // const currentDate = new Date();

    // const currentMonth = currentDate.getMonth() + 1;

    // if (currentMonth <= 3) {
    //   this.fourMonthPeriodType = 1;
    // } else if (currentMonth <= 6) {
    //   this.fourMonthPeriodType = 2;
    // } else if (currentMonth <= 9) {
    //   this.fourMonthPeriodType = 3;
    // } else {
    //   this.fourMonthPeriodType = 4;
    // }

    await this.GetGanttObjectives();
    this.$http
      .get("/api/Directions/DirectionsByCompany", {
        params: {
          company: this.currentCompany
        }
      })
      .then(({ data }) => {
        this.directions = formatArrayToElSelect(data);
      })
      .catch(() => {});
  },
  methods: {
    onTaskClose() {
      let thiss = this;
      gantt.attachEvent("onLightboxCancel", function (id) {
        var taskOriginal = gantt.getTaskBy("id", id);
        TaskClose(taskOriginal, id, thiss, gantt);
        return false;
      });
    },

    handleClick(type) {
      this.activeName = type;
      this.GetGanttObjectives();
    },

    loadObjetiveNotification(thiss) {
      this.$store.dispatch("updateBadgetCount", thiss);
    },

    controlsOfDate(parentDateInit, parentDateEnd, taskDateInit, tasktDateEnd) {
      // let thiss = this;

      if (taskDateInit < parentDateInit) {
        gantt.alert({
          text: "La fecha inicial no puede iniciar antes que el del Objectivo",
          title: "Error!",
          ok: "OK",
          type: "error"
        });
        return false;
      }
      if (taskDateInit > parentDateEnd) {
        gantt.alert({
          text: "La fecha inicial no puede iniciar después de la fecha fin del Objectivo",
          title: "Error!",
          ok: "OK",
          type: "error"
        });
        return false;
      }
      if (tasktDateEnd > parentDateEnd) {
        gantt.alert({
          text: "La fecha fin no puede finalizar después que el del Objectivo",
          title: "Error!",
          ok: "OK",
          type: "error"
        });
        return false;
      }
      return true;
    },
    formGantt() {
      let thiss = this;
      //Save objctives/tasks

      gantt.attachEvent("onLightboxSave", async function (id, task) {
        try {
          const taskOriginal = gantt.getTaskBy("id", id);
          const tareaOriginalClonada = gantt.copy(taskOriginal);
          const taskClonada = gantt.copy(task);

          if (!task.$new) {
            await thiss.validateSupervisor(
              taskOriginal[0].owner_id,
              thiss.currentUser.EmployeeId
            );
          }

          await SaveGantt(
            thiss.isSupervisor,
            taskClonada,
            tareaOriginalClonada,
            id,
            gantt,
            thiss
          );
          return false;
        } catch (error) {
          console.error("Error:", error);
        }
      });

      //Delete Objectives
      gantt.attachEvent("onLightboxDelete", (id) => {
        var taskOriginal = gantt.getTaskBy("id", id);
        thiss.OpenObjeID =
          taskOriginal[0].parent != 0 ? taskOriginal[0].parent : id;

        DeleteGantt(taskOriginal, id, gantt, thiss);
        return false;
      });

      //aprovar tarea realizada
      gantt.attachEvent("onLightboxButton", async function (button_id) {
        if (button_id == "gantt_complete_btn") {
          var id = gantt.getState().lightbox;
          var task = gantt.getTask(id);

          await thiss.validateSupervisor(
            task.owner_id,
            thiss.currentUser.EmployeeId
          );
          CompleteGantt(thiss.isSupervisor, task, id, gantt, thiss);
          return false;
        }
      });
    },
    GetGanttObjectives() {
      let thiss = this;
      gantt.clearAll();
      this.tasks.data = [];
      this.loading = true;
      switch (this.activeName) {
        case 1: //Todas Las Tareas
          GetObjectives(gantt, thiss, 1);
          break;
        case 2: //Tareas Retrasada
          GetObjectives(gantt, thiss, 2);
          break;
        case 3: //Tareas Semana Actual
          GetObjectives(gantt, thiss, 3);
          break;
        case 4: //Tareas Próxima Semana
          GetObjectives(gantt, thiss, 4);
          break;
        case 5: //Tareas del Mes
          GetObjectives(gantt, thiss, 5);
          break;
        case 6: //Tareas Próximo mes
          GetObjectives(gantt, thiss, 6);
          break;
        default:
          return true;
      }
    },
    getStadistict() {
      let thiss = this;
      this.loadingStadistic = true;
      GetStadistict(thiss, this.activeName);
    },
    getIconST(name) {
      if (name === "Financiera") return "el-icon-bank-card accent-text";
      else if (name === "Del cliente") return "el-icon-s-custom success-text";
      else if (name === "Procesos internos") return "el-icon-coin warning-text";
      else if (name === "Desarrollo y Aprendizaje")
        return "el-icon-setting purple-text";
    },
    handleChangeDirection(directionId) {
      this.directionId = directionId;
      this.getEmployees();
      this.GetGanttObjectives();
    },
    updateSelectedEmployee(employeeId) {
      this.employeeId = employeeId;
      this.GetGanttObjectives();
    },
    updateSelectedStatus(statusSelect) {
      this.statusSelect = statusSelect;
      this.GetGanttObjectives();
    },
    updateSelectedResponsable(responsableSelect) {
      this.responsableSelect = responsableSelect;
      this.GetGanttObjectives();
    },
    handleryear(_year) {
      this.year = _year;
      this.GetGanttObjectives();
    },
    handlerMonth(_month) {
      this.month = _month;
      this.GetGanttObjectives();
    },
    handleChangeFourMonthPeriodType(fourMonthPeriodType) {
      this.fourMonthPeriodType = fourMonthPeriodType;

      this.GetGanttObjectives();
    },
    getEmployees() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      if (this.directionId > 0) {
        uri = `/api/Employees/GetEmployeeByCriteria?DepartmentID=${this.deparmentId}&DirectionID=${this.directionId}`;
      } else {
        uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;
      }

      this.$http
        .get(uri)
        .then((response) => {
          this.employees = response.data;
        })
        .catch(() => {});
    },
    expandAll() {
      gantt.batchUpdate(function () {
        gantt.eachTask(function (task) {
          gantt.open(task.id);
        });
      });
    },
    collapseAll() {
      gantt.batchUpdate(function () {
        gantt.eachTask(function (task) {
          gantt.close(task.id);
        });
      });
    },
    loadData(dataset, clearAll) {
      if (clearAll) {
        gantt.clearAll();
      }
      gantt.parse(dataset);
    },
    clearData() {
      gantt.clearAll();
    },
    Setlightbox() {
      let thiss = this;
      Setlightbox(thiss, gantt);
    },
    getEmployeesLits() {
      let uri = "";
      const company = this.currentCompany;
      const employeeId = this.currentUser.EmployeeId;

      uri = `/api/CMI/Objetives/GetUsersObjetivos?CompanySelected=${company}&employeeid=${employeeId}`;

      this.$http
        .get(uri)
        .then((response) => {
          response.data.forEach((element) => {
            this.listOwners.push({
              id: element.EmployeeID,
              text: element.Name.split(" ")[0]
            });
          });
        })
        .catch(() => {});
    },
    async GetEmployeeByName() {
      let thiss = this;
      GetEmployee(thiss);
    },
    async validateSupervisor(responsableId, currentEmployeeId) {
      // var isSupervisor = false;

      try {
        const response = await this.$http.get(
          `/api/CMI/Objetives/ValidateSupervisorGantt?responsableId=${responsableId}&currentEmployeeId=${currentEmployeeId}`
        );
        this.isSupervisor = response.data;
        // return response.data;
      } catch (err) {
        throw ("error", err);
      }

      // this.$http
      //   .get(
      //     `/api/CMI/Objetives/ValidateSupervisorGantt?responsableId=${responsableId}&currentEmployeeId=${currentEmployeeId}`
      //   )
      //   .then((resp) => {sSUPERVISOR", resp);
      //     this.isSupervisor = resp.data;
      //     // return resp.data;
      //   })
      //   .catch((err) => {
      //     this.$message({
      //       type: "error",
      //       message: err.message
      //     });
      //   })
      //   .finally((e) => (this.loading = false));
      // return this.isSupervisor;
    },
    async validateSupervisorAsync(responsableId, currentEmployeeId) {
      var isSupervisor = false;
      await this.$http
        .get(
          `/api/CMI/Objetives/ValidateSupervisorGantt?responsableId=${responsableId}&currentEmployeeId=${currentEmployeeId}`
        )
        .then((resp) => {
          isSupervisor = resp.data;
          return resp.data;
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        });
      return isSupervisor;
    },
    async confirmRoles() {
      let rtn;
      if (this.currentUser.EmployeeId == 37) {
        return (rtn = true);
      } else {
        rtn = this.employeesByDirection.length > 0 ? true : false;
      }
      return rtn;
    },
    handleUploadOnSuccess(response) {
      this.fileList = response[0];
      if (this.TaskID.includes("SubTask")) {
        //SubTasks
        this.$http
          .post(
            `/api/cmi/SubTaskGantt/AddEvidenceSubTaskGantt?ID=${this.TaskID}&Evidence=${this.fileList.Url}`
          )
          .then(() => {
            let message = "Evidencia de la SubTarea fue agregado exitosamente";
            this.$message.success(message);
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err.message
            });
          })
          .finally(() => {
            this.GetGanttObjectives();
          });
        this.dialogVisible = false;
        return true;
      }
      this.$http
        .post(
          `/api/cmi/task/AddEvidenceTaskGantt?ID=${this.TaskID}&Evidence=${this.fileList.Url}`
        )
        .then(() => {
          let message = "Evidencia de la Tarea fue agregado exitosamente";
          this.$message.success(message);
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        })
        .finally(() => {
          this.GetGanttObjectives();
        });
      this.dialogVisible = false;
    },
    handleChange() {
      this.filesUpload = 1;
    },
    handleRemove() {
      this.filesUpload = 0;
    },
    submitUpload() {
      this.$refs.uploadFile.submit();
    },
    cancellUpload() {
      if (this.TaskID.includes("SubTask")) {
        //SubTasks
        this.$http
          .post(
            `/api/cmi/SubTaskGantt/CancellEvidenceSubTaskGantt?ID=${this.TaskID}&Progress=${this.TaskProgressOlds}`
          )
          .then(() => {
            let message = "Evidencia de la SubTarea fue cancelada exitosamente";
            this.$message.info(message);
          })
          .catch((err) => {
            this.$message({
              type: "error",
              message: err.message
            });
          })
          .finally(() => {
            this.GetGanttObjectives();
          });
        this.dialogVisible = false;
        this.dialogVisible = false;
      }
      this.$http
        .post(
          `/api/cmi/task/CancellEvidenceTaskGantt?ID=${this.TaskID}&Progress=${this.TaskProgressOlds}`
        )
        .then(() => {
          let message = "Evidencia de la Tarea fue cancelada exitosamente";
          this.$message.info(message);
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: err.message
          });
        })
        .finally(() => {
          this.GetGanttObjectives();
        });
      this.dialogVisible = false;
    },
    handleExceed(files) {
      this.$message.warning(
        `El límite es 1, haz seleccionado ${
          files.length
        } archivos esta vez, añade hasta ${files.length + 0}`
      );
    },

    toggleGridFunction() {
      this.toggleGrid = !this.toggleGrid;
      gantt.config.show_grid = !gantt.config.show_grid;
      gantt.render();
    },
    toggleChartFunction() {
      this.toggleChart = !this.toggleChart;
      gantt.config.show_chart = !gantt.config.show_chart;
      gantt.render();
    },
    onEvidenceClose() {
      this.$refs.uploadFile.clearFiles();
    }
  },
  watch: {
    PerpectiveId() {
      this.GetGanttObjectives();
    },
    // Strategic() {
    //   this.GetGanttObjectives();
    // },
    showCards() {
      this.heightStyle.height = this.showCards ? "140vh" : "160vh";
    }
  }
};
</script>

<style lang="scss" scoped :src="cssImportPath">
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: "Nunito Sans", Helvetica, Arial, sans-serif;
}
.container {
  // height: 130vh;
  width: 100%;
}
.left-container {
  overflow: hidden;
  position: relative;
  height: 60%;
  margin-top: 10px;
}
.btnDyA {
  background-color: rgb(138, 38, 138);
  border-color: rgb(138, 38, 138);
  color: white;
}
// @import cssImportPath;
// "../../../../../gantt_8.0.1_individual/codebase/skins/dhtmlxgantt_material.css";
</style>
